const surveyRouter = [
  {
    path: '/survey/detail/:id(\\d+)',
    name: 'SurveyDetail',
    component: () => import('@/views/survey/detail')
  },
  {
    path: '/survey/:id(\\d+)',
    name: 'SurveyBefore',
    component: () => import('@/views/survey/before')
  },
  {
    path: '/survey/success',
    name: 'SurveySuccess',
    component: () => import('@/views/survey/success')
  },
  {
    path: '/survey/overdue',
    name: 'SurveyOverdue',
    component: () => import('@/views/survey/overdue')
  }
]

export default surveyRouter



// WEBPACK FOOTER //
// ./src/router/modules/survey.js